import React from "react";

const PromoteursHeader = ({
  showSearch = true,
  searchfilter,
  setSearchfilter,
  handleItemSearch,
  showButton,
  buttonText,
  buttonCallBack,
}) => {
  const handleInputChange = (e) => {
    const { value } = e.target;
    setSearchfilter(value);
    handleItemSearch();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleItemSearch();
    }
  };

  return (
    <div className="d-flex bg-white headerRadius5 headerContainer align-items-center justify-content-end">
      {showSearch && (
        <div className="d-flex align-items-center gap10 flex-1">
          <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
            <img src="./icons/search.svg" alt="search" height={16} width={16} />
            <input
              type="search"
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
              value={searchfilter}
              placeholder="Rechercher"
              className="inputSearch border-0"
            />
          </div>

          {handleItemSearch ? (
            <button
              className="border-0 bg-pink px-20 py-10 radius5 hoverOpacity"
              onClick={handleItemSearch}
            >
              <img
                src="./icons/search_white.svg"
                alt="search"
                height={16}
                width={16}
              />
            </button>
          ) : null}
        </div>
      )}
      <div className="filter d-flex align-items-center gap40">
        {showButton && (
          <button
            className="d-flex align-items-center gap10 radius5 px-20 py-10 border-0 t02 bg-pink text-white hoverOpacity"
            onClick={buttonCallBack}
          >
            <img src="./icons/add_promoteur.svg" alt="" />
            <p className="d-none d-xxl-flex">{buttonText}</p>
          </button>
        )}
      </div>
    </div>
  );
};

export default PromoteursHeader;
